import React from 'react';
import { useTranslation } from 'react-i18next';

const roleLabels = {
    3: 'news.franchisee',
    4: 'news.teacher',
};

const NewsVisibleRoles = ({ value }) => {
    const { t } = useTranslation();

    if (!Array.isArray(value)) return null;

    const roleIds = value.map(item => item.role_id);
    const roleNames = roleIds.map(id => roleLabels[id]);

    if (roleNames.length === 0) return <span>{t('news.noRoles')}</span>;

    const translatedRoles = roleNames.map(key => t(key)).join(', ');
    return <span>{translatedRoles}</span>;
};

export default NewsVisibleRoles;
